import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useQueryClient, useMutation } from 'react-query';
import { QueryKey } from '../../domain/dtos/query-key.js';
import { SavePost } from '../../usecases/save-post.js';

const useSavePost = () => {
  const container = useContainer();
  const queryClient = useQueryClient();
  return useMutation([QueryKey.savePost], ({
    payload,
    id
  }) => new SavePost(container.get(HttpClient)).execute(payload, id), {
    onSuccess: () => {
      queryClient.refetchQueries(QueryKey.listSections);
    }
  });
};

export { useSavePost };
